module.exports = __webpack_public_path__ + "img/img_communaute3.ad2e9fce.jpg";